import * as Switch from '@wandb/weave/components/Switch';
import React from 'react';
import {twMerge} from 'tailwind-merge';

import {SettingLabel} from '../WorkspaceDrawer/Settings/components/SettingLabel';

export const WorkspaceTemplateToggleRow = ({
  description,
  isChecked,
  isDisabled,
  label,
  onCheckedChange,
}: {
  description?: string;
  isChecked: boolean;
  isDisabled: boolean;
  label: string;
  onCheckedChange: (checked: boolean) => void;
}) => {
  return (
    <div className={twMerge('flex flex-col')}>
      <div className={twMerge('flex', 'items-center justify-between')}>
        <SettingLabel text={label} className={twMerge('w-fit')} />
        <Switch.Root
          aria-label={label}
          disabled={isDisabled}
          onCheckedChange={onCheckedChange}
          size="small">
          <Switch.Thumb checked={isChecked} size="small" />
        </Switch.Root>
      </div>
      {description && (
        <h4
          className={twMerge(
            'font-[inherit] text-sm leading-[140%] text-moon-500',
            'mr-16'
          )}>
          {description}
        </h4>
      )}
    </div>
  );
};
